
import EDDialog from '../../../../../../../../../BaseComponents/Dialog/EDDialog';
import {
  getMonth,
  getMonthText,
  getYear,
} from '../../../../../../../../../Utils/dateUtils';

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fromDateString: string | null;
  bokforderDate: string | undefined;
}

const BokforderPeriodSummeringInfoDialog: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const fromDate = props.fromDateString ? new Date(props.fromDateString) : '';
  const bokforderDate = props.bokforderDate
    ? new Date(props.bokforderDate)
    : '';

  const isSameYear =
    fromDate != '' && bokforderDate != ''
      ? getYear(fromDate) === getYear(bokforderDate)
      : true;

  const fromMonthSameYearString = isSameYear
    ? ''
    : fromDate.toString() != 'Invalid Date' && fromDate != ''
    ? `(${getYear(fromDate)})`
    : '';

  const fromMonthString =
    fromDate.toString() != 'Invalid Date' && fromDate != ''
      ? fromMonthSameYearString != ''
        ? getMonthText(getMonth(fromDate)) + fromMonthSameYearString
        : getMonthText(getMonth(fromDate))
      : '';

  const bokfMonthSameYearString = isSameYear
    ? ''
    : bokforderDate
    ? `(${getYear(bokforderDate)})`
    : '';

  const bokfMonthString =
    bokforderDate.toString() != 'Invalid Date' && bokforderDate != ''
      ? bokfMonthSameYearString != ''
        ? getMonthText(getMonth(bokforderDate)) + bokfMonthSameYearString
        : getMonthText(getMonth(bokforderDate))
      : '';

  return (
    <EDDialog
      footerActions={[
        {
          label: 'Ok',
          onClick: () => {
            props.setOpen(false);
          },
        },
      ]}
      open={props.open}
      onClose={() => {
        props.setOpen(false);
      }}
      title={'Information om periodisering'}
    >
      {`Fördelningen till intervall 
      ${fromMonthString} - ${bokfMonthString}
      kommer summeras ihop på period 
      ${bokfMonthString} `}
    </EDDialog>
  );
};

export default BokforderPeriodSummeringInfoDialog;
